"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMPORT_PROCESSING_STALE_AFTER_MS = exports.MAX_TRANSACTIONS_FILE_SIZE_SYNC_IMPORT = exports.MAX_TRANSACTIONS_ROW_COUNT_SYNC_IMPORT = exports.IMPORT_CHUNK_SIZE = exports.MAX_IMPORT_COLUMNS_IN_IMPORT = exports.MAX_FLATFILE_UPLOAD_FILE_SIZE_BYTES = exports.MAX_FLATFILE_UPLOAD_FILE_SIZE_MB = exports.MAX_IMPORT_FILE_SIZE = exports.MAX_COUNT_IN_IMPORT_CHECKING = exports.MAX_COUNT_IN_IMPORT = exports.MAX_COUNT_IN_SYNC_IMPORT = exports.paymentImportKeys = exports.membershipImportKeys = exports.contactImportKeys = void 0;
const contactIdentityKeys = ["firstName", "lastName", "email"];
const contactDetailKeys = [
    "secondaryEmail",
    "language",
    "address",
    "city",
    "region",
    "postalCode",
    "country",
    "phone",
    "lists",
    "note",
    "companyName",
    "householdName",
    "subscriptionStatus",
];
exports.contactImportKeys = [...contactIdentityKeys, ...contactDetailKeys];
// `lists` sits with the payment columns rather than with the other contact ones.
const paymentBlockKeys = [
    "formTitle",
    "rateTitle",
    "lists",
    "fund",
    "paymentMethod",
    "eligibleAmount",
    "receiptUrl",
    "receiptNumber",
    "ticketUrl",
    "annotation",
];
// contactDetailKeys without `lists` — but the company comes before the note here, the order the payment and
// membership templates were signed off with. Add a contact column to both lists or one template will miss it.
const trailingContactKeys = [
    "secondaryEmail",
    "language",
    "address",
    "city",
    "region",
    "postalCode",
    "country",
    "phone",
    "companyName",
    "note",
    "householdName",
    "subscriptionStatus",
];
// The widest list, and the order an organization reads in the template and in the mapping step.
exports.membershipImportKeys = [
    "amount",
    ...contactIdentityKeys,
    "date",
    "expirationDate",
    ...paymentBlockKeys,
    ...trailingContactKeys,
];
// Only a membership expires.
exports.paymentImportKeys = exports.membershipImportKeys.filter((key) => key !== "expirationDate");
exports.MAX_COUNT_IN_SYNC_IMPORT = 200;
exports.MAX_COUNT_IN_IMPORT = 15_000;
exports.MAX_COUNT_IN_IMPORT_CHECKING = 3_000;
exports.MAX_IMPORT_FILE_SIZE = 20 * 1024 * 1024; // 20MB
exports.MAX_FLATFILE_UPLOAD_FILE_SIZE_MB = 2;
exports.MAX_FLATFILE_UPLOAD_FILE_SIZE_BYTES = exports.MAX_FLATFILE_UPLOAD_FILE_SIZE_MB * 1024 * 1024;
exports.MAX_IMPORT_COLUMNS_IN_IMPORT = 100;
exports.IMPORT_CHUNK_SIZE = 1024 * 1024; // 1MB
exports.MAX_TRANSACTIONS_ROW_COUNT_SYNC_IMPORT = 1;
exports.MAX_TRANSACTIONS_FILE_SIZE_SYNC_IMPORT = (1024 * 1024) / 1000; // 1kB
exports.IMPORT_PROCESSING_STALE_AFTER_MS = 6 * 60 * 60 * 1000;
